<template>
  <div class="countdown_digit__wrapper" :class="{ flip: isFlipping }">
    <b class="countdown_digit__card">
      <b class="card__top">{{ currentValue }}</b>
      <b class="card__bottom" :data-value="prevValue" />
      <b class="card__back" :data-value="prevValue">
        <b class="card__bottom" :data-value="currentValue" />
      </b>
    </b>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  value: string
}>()

const currentValue = ref(props.value.slice(-2))
const prevValue = ref(currentValue.value)
const isFlipping = ref(false)

watch(
  () => props.value,
  (newValue) => {
    if (newValue !== currentValue.value) {
      prevValue.value = currentValue.value
      currentValue.value = newValue
      isFlipping.value = true

      nextTick()
      setTimeout(() => {
        isFlipping.value = false
      }, 600)
    }
  },
)
</script>

<style lang="postcss">
.countdown_digit__wrapper {
  @apply inline-block;
}
.countdown_digit__card {
  @apply relative block;
  font-size: 35px;

  @screen desktop {
    font-size: 64px;
    padding-bottom: 0.72em;
    line-height: 0.95;
  }
}
.card__top,
.card__bottom,
.card__back::before,
.card__back::after {
  @apply flex justify-center bg-primary text-scheme-main;
  height: 25px;
  border-radius: 4px 4px 0 0;
  backface-visibility: hidden;
  transform-style: preserve-3d;
  width: 30px;
  transform: translateZ(0);

  @screen desktop {
    width: 70px;
    height: 0.72em;
    padding-top: 0.25em;
  }
}
.card__bottom {
  @apply pointer-events-none absolute left-0 overflow-hidden border-t border-black-bis bg-primary text-scheme-main belowDesktop:h-[25px];
  border-radius: 0 0 4px 4px;

  @screen desktop {
    top: 50%;
  }
}
.card__bottom::after {
  @apply block;
  margin-top: -26px;

  @screen desktop {
    margin-top: -0.72em;
  }
}
.card__back::before,
.card__bottom::after {
  content: attr(data-value);
}
.card__back {
  @apply pointer-events-none absolute left-0 top-0 h-full;
}
.card__back::before {
  @apply relative overflow-hidden;
  z-index: -1;
}
.flip .card__back::before {
  -webkit-animation: flipTop 0.3s cubic-bezier(0.37, 0.01, 0.94, 0.35);
  animation: flipTop 0.3s cubic-bezier(0.37, 0.01, 0.94, 0.35);
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  transform-origin: center bottom;
}
.flip .card__back .card__bottom {
  transform-origin: center top;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: flipBottom 0.6s cubic-bezier(0.15, 0.45, 0.28, 1);
  animation: flipBottom 0.6s cubic-bezier(0.15, 0.45, 0.28, 1);
}
@-webkit-keyframes flipTop {
  0% {
    transform: rotateX(0deg);
    z-index: 2;
  }
  0%,
  99% {
    opacity: 0.99;
  }
  100% {
    transform: perspective(150px) rotateX(-90deg);
    opacity: 0;
  }
}
@keyframes flipTop {
  0% {
    transform: rotateX(0deg);
    z-index: 2;
  }
  0%,
  99% {
    opacity: 0.99;
  }
  100% {
    transform: perspective(150px) rotateX(-90deg);
    opacity: 0;
  }
}
@-webkit-keyframes flipBottom {
  0%,
  50% {
    z-index: -1;
    transform: perspective(150px) rotateX(90deg);
    opacity: 0;
  }
  51% {
    opacity: 0.99;
  }
  100% {
    opacity: 0.99;
    transform: rotateX(0deg);
    z-index: 5;
  }
}
@keyframes flipBottom {
  0%,
  50% {
    z-index: -1;
    transform: perspective(150px) rotateX(90deg);
    opacity: 0;
  }
  51% {
    opacity: 0.99;
  }
  100% {
    opacity: 0.99;
    transform: rotateX(0deg);
    z-index: 5;
  }
}
</style>
